module.exports = __webpack_public_path__ + "static/media/Home Page_website-32.234afd27.png";